import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import Headshot from "../components/Headshot";
import YoutubeEmbed from "../components/YoutubeEmbed";
import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Telecommunications - Elm Street</title>
        <meta
          name="description"
          content="Elm Street's phone automation services provide a 24/7, on-demand receptionist to answer and route calls to agents, staff and team members."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/telecommunications" />
        <meta property="og:title" content="Telecommunications - Elm Street" />
        <meta
          property="og:description"
          content="Elm Street's phone automation services provide a 24/7, on-demand receptionist to answer and route calls to agents, staff and team members."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />




      <ExitModal>
      <div style={{padding:"25px"}}>
                <div style={{textAlign:"center", paddingBottom:"10px"}}> <Typography variant="h4" component="h2" style={{ color: "#333666", textAlign: "center", paddingBottom:"10px" }}>Take The 30-Day <br /><span style={{color:"#f69c26"}}>Marketing Challenge!</span></Typography>
                </div>
                <div style={{textAlign:"center", paddingBottom:"10px"}}>A free downloadable guide with Simple steps to elevate your marketing in less than 1-month.
                </div>
                
                <FormMini buttonText="accept the challenge" successMsg={<div style={{textAlign:"center"}}><Button variant="contained" color="secondary" href="/assets/30daymarketingchallenge.pdf">Download the PDF</Button></div>}
              formName="es2_marketing_challenge" listId="148009" utmOverride="exit_intent" />
                
         </div>
         <div style={{textAlign:"center"}}>
         <Image
                    src="/mcgo.jpg"
                    width="590px"
                    height="242px"
                    alt="30 Day Marketing Challenge FREE Guide"
                   
                  />
                  </div>
     </ExitModal>






      <div
        style={{
          backgroundImage: "url('telecombg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street - Telecommunications"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>telecom</span>
                  </Typography>
                  <p>24/7 Solutions Designed For Responsiveness.</p>

                  <Button variant="contained" color="secondary" href="#form">
                    take a tour
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div>
        <Container maxWidth="lg" style={{ paddingTop: "110px", paddingBottom: "75px" }}>
          <Grid container columnSpacing={8}>
            <Grid item md={5} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h5" component="h5">
                Whether it's after-hours,
                <br />
                vacation, <span style={{ color: "#f69c26" }}>or even a pandemic...</span>
              </Typography>
              Elm Street's phone automation services provide a 24/7, on-demand receptionist to answer and route calls to
              agents, staff and team members.
              <br /> <br />
              <Typography variant="h5" component="h5">
                <span style={{ color: "#f69c26" }}>key </span>
                features:
              </Typography>
              <br />
              <strong>Agent Directories via MLS</strong> (speech-based)
              <br />
              <strong>“Floor Duty” Scheduler with Simul-Ring</strong>
              <br />
              <strong>Call Recordings</strong> (for sales interactions)
              <br />
              <strong>Curbside Lead Generation</strong>
            </Grid>

            <Grid item md={7} xs={12}>
              <YoutubeEmbed embedUrl="https://www.youtube.com/embed/KNL7iKawpl8" />
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('horizonbg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "105px", paddingBottom: "55px", marginTop: "55px" }}>
          <Grid container columnSpacing={8} style={{ paddingBottom: "45px;" }}>
            <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
              <Headshot src="/headshots/jsimms.jpg" name="" title="" alt="Joe Simms RE/MAX Professionals - Broker" />
            </Grid>
            <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
                joe simms
              </Typography>
              <strong style={{ color: "#ffffff" }}>
                RE/MAX Professionals - Broker
                <br />
                Louisville, KY
                <br />
              </strong>
              <br />
              <span style={{ color: "#ffffff" }}>
                “We started using the VoicePad On-Demand system after-hours to transfer calls to agents using
                speech-recognition. We've since moved to using the system on a full-time basis. The agents love it. The
                admins love it. And, we saved a lot of money doing it. Now, our admins are focused on helping agents vs
                answering the phones. This is the best thing we've done as a brokerage.”
              </span>
            </Grid>
          </Grid>

          <Grid container columnSpacing={8} style={{ paddingBottom: "45px;" }}>
            <Grid item md={3} sm={12} style={{ paddingBottom: "24px" }}>
              <Headshot
                src="/headshots/cstallings.jpg"
                name=""
                title=""
                alt="Claudia Stallings Coldwell Banker Wallace &amp; Wallace - VP Residential Sales"
              />
            </Grid>
            <Grid item md={9} sm={12} style={{ paddingBottom: "24px" }}>
              <Typography variant="h5" component="h5" style={{ color: "#f69c26" }}>
                claudia stallings
              </Typography>
              <strong style={{ color: "#ffffff" }}>
                Coldwell Banker Wallace &amp; Wallace - VP Residential Sales
                <br />
                Knoxville, TN
                <br />
              </strong>
              <br />
              <span style={{ color: "#ffffff" }}>
                “In this environment where leads must be answered within seconds, we began looking for a cost-effective
                way to get the client connected directly to the agent in real-time after hours. We knew about
                VoicePad&reg; through a colleague who was using it and decided to take a look.
                <br />
                <br />
                Their menus and voice-recognition services are now keeping our callers on the phone and agents are being
                connected for a live conversation. We are also able to track what callers need based on their menu
                selections and see that almost 38% of all after-hours calls are being successfully routed to specific
                agents, while 26% of our calls are property inquiries. Those inquiries are going to a pool of agents who
                are rushing to be the first one to pick up the call for a chance at new business. We're pleased to have
                evolved our after-hours service for faster response time for our client and a better opportunity to
                connect for our agents.”
              </span>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              schedule a demo
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746" }}>Connect with our team to explore your unique needs.</strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      formName="es2_telecommunications"
                      listId="147994"
                      successUrl="thankyou-simplified"
                      fieldList={["first_name", "last_name", "email", "phone", "roll"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
